import React from 'react';


const SuperAdminApprovedSheet = () => {
    return (
        <div className="view-approved-sheets-container" style={{ fontFamily: "Arial, sans-serif" }}>
            <div className="content-section">
                <h3 style={{ fontSize: "20px", fontWeight: "400", color: "#000000", marginTop: "20px", marginBottom: "10px" }}>
                    How can I check if the timesheet has been approved?
                </h3>
                <p className="description">
                    This section allows you to track all the timesheets that have been approved by both the approval manager and the super admin. 
                    Only records that have successfully gone through the entire approval process will be displayed here. 
                    This helps in maintaining a proper record of approved timesheets for future reference and reporting.
                </p>

                <h4 className="section-heading">Approved Sheets</h4>

                    <img
                        
                        src="https://res.cloudinary.com/danfpnuui/image/upload/v1737465931/Screenshot_2025-01-21_153153_rgj0ph.png"
                        alt="Employee Table Screenshot"
                        style={{ maxWidth: "70%"}}
                    />
                </div>

                <div>
                    <p className="closing-text">
                        The above screenshot illustrates how approved timesheets are displayed. Each row contains essential details, such as:
                    </p>
                    <ul className="closing-text">
                        <li><strong>Timesheet ID (T.ID):</strong> A unique identifier for each timesheet.</li>
                        <li><strong>Employee Name:</strong> The name of the employee whose timesheet is being reviewed.</li>
                        <li><strong>Period:</strong> The time frame for which the hours were logged.</li>
                        <li><strong>Total Hours:</strong> The total number of hours worked by the employee in the given period.</li>
                        <li><strong>Client & End Client:</strong> The company for which the employee worked and the end client involved.</li>
                        <li><strong>Status:</strong> Indicates whether the timesheet is approved or still under review.</li>
                        <li><strong>Comments:</strong> Any additional remarks from the approval manager or super admin.</li>
                    </ul>
                    <p className="closing-text">
                        Having this detailed view ensures better tracking and management of work hours. If a timesheet is "approved", it means all necessary verifications 
                        have been completed. If there are any "comments", they provide additional insights regarding the approval decision.
                    </p>
                </div>

                <img
                        
                        src="https://res.cloudinary.com/danfpnuui/image/upload/v1737465931/Screenshot_2025-01-21_153153_rgj0ph.png"
                        alt="Employee Table Screenshot"
                        style={{ maxWidth: "70%"}}
                        />
                <h4 className="section-heading">Steps to View Approved Sheets</h4>
                <p className="description">
                    <strong>Step 1:</strong> Navigate to the <strong>Approved Sheets</strong> section after logging into your account.
                </p>

                
                <p className="description">
                    <strong>Note:</strong> If no timesheets have been approved yet, this section will be empty.
                </p>
                <p className="description">
                    <strong>Step 2:</strong> If you see approved timesheets listed, you have the option to "download the report" for record-keeping.
                    The report contains all necessary details, making it easier for tracking and compliance.
                </p>
            </div>
        
    );
};

export default SuperAdminApprovedSheet;
